import Vue from 'vue'
import AOS from 'aos';
import 'aos/dist/aos.css';
import App from './App.vue'
// import router from './router'


Vue.config.productionTip = false

new Vue({
  created() {
    AOS.init({
      useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
      debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
      throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
      // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
      offset: 20, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 1000, // values from 0 to 3000, with step 50ms
      easing: 'ease', // default easing for AOS animations
      once: true, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: 'top-center', // defines which position of the element regarding to window should trigger the animation
    });
  },
  // router,
  render: h => h(App),
}).$mount('#app')
